<template lang="pug">
.result
  h3.result-title.d-flex.justify-content-between
    span ส่วนที่ 4 ประวัติการทำงาน (Employment Record)
    span(@click='$store.commit("SET_STEP", 4)', role='button') แก้ไข

  .employment
    .employment-item(v-for='(item, index) in employmentRecord')
      .row.result-item
        strong.col-sm-2 ชื่อบริษัท
        span.col-sm-2 {{ item.company_name }}

        strong.col-sm-2 ลักษณะธุรกิจ
        span.col-sm-2 {{ item.business_type }}

        strong.col-sm-2 ตำแหน่งงาน
        span.col-sm-2 {{ item.position }}

      .row.result-item
        strong.col-sm-2 วันที่เข้าทำงาน
        span.col-sm-2 {{ item.since }}

        strong.col-sm-2 วันที่ลาออก
        span.col-sm-2 {{ item.to }}

        strong.col-sm-2 งานที่รับผิดชอบ
        span.col-sm-2 {{ item.responsible_work }}

      .row.result-item
        strong.col-sm-2 สาหตุที่ลาออก
        span.col-sm-2 {{ item.resignation }}
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['employmentRecord']),
  },
}
</script>

<style lang="scss" scoped>
.employment-item {
  &:not(:last-child) {
    margin-bottom: 2rem;
  }
}
</style>